/**
 * Auth Configuration — Clerk
 *
 * Production: Uses Clerk for authentication (@clerk/react)
 *
 * This module exports:
 * - clerkPublishableKey: The Clerk publishable key
 */

const clerkKey =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_CLERK_PUBLISHABLE_KEY) ||
  (typeof process !== 'undefined' && process.env?.VITE_CLERK_PUBLISHABLE_KEY) ||
  '';

/**
 * Clerk publishable key for ClerkProvider
 */
export const clerkPublishableKey = clerkKey;
